// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"f7fd673e","721":"953510a1"}[chunkId] + ".css";
};